export default {
  most_popular: '#{{rank}} Mais Popular',
};
